export interface AudioGuide {
  when: string
  how: string
  intention: string
}

export interface AudioTrack {
  id: string
  title: string
  desc: string
  duration: string
  src: string
  guide: AudioGuide
}

export const AUDIOS: AudioTrack[] = [
  {
    id: 'audio-1',
    title: 'Mañana de Sanación',
    desc: 'Un canto suave para el alma que despierta el corazón con ternura, paz y renovación. Este audio crea un espacio sagrado para comenzar el día en armonía, permitiendo que la luz divina restaure tu interior y alinee tu espíritu con un nuevo propósito.',
    duration: '8:24',
    src: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Manana_de_Sanacion.mp3?v=1777006277',
    guide: {
      when: 'Al despertar, durante tu oración de la mañana o al iniciar tu tiempo devocional.',
      how: 'Escúchalo en quietud, respirando profundamente y entregando tu día a Dios.',
      intention:
        'Recibir paz, claridad y fortaleza espiritual desde las primeras horas del día.',
    },
  },
  {
    id: 'audio-2',
    title: 'Paz Profunda en 852 Hz',
    desc: 'Una atmósfera sonora creada para aquietar la mente, calmar el corazón y elevar el espíritu. Este audio invita a soltar las cargas internas y entrar en un estado de descanso profundo, donde el alma puede sentir consuelo, quietud y presencia divina.',
    duration: '12:00',
    src: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Paz_Profunda_en_852_Hz.mp3?v=1777006274',
    guide: {
      when: 'En momentos de ansiedad, cansancio emocional, oración silenciosa o antes de dormir.',
      how: 'Úsalo en un lugar tranquilo, con los ojos cerrados, permitiendo que cada sonido te lleve a la quietud.',
      intention:
        'Liberar tensión espiritual y descansar en una paz más profunda.',
    },
  },
  {
    id: 'audio-3',
    title: 'Revelación del Planeta Brumoso',
    desc: 'Un viaje sonoro místico hacia las profundidades del ser. Este audio acompaña procesos de transformación interior, ayudando a liberar cargas del pasado y abrir espacio para una nueva vibración de amor, restauración y revelación espiritual.',
    duration: '10:15',
    src: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Revelacion_del_Planeta_Brumoso.mp3?v=1777006283',
    guide: {
      when: 'Durante la meditación, en tiempos de reflexión profunda o cuando busques dirección espiritual.',
      how: 'Escúchalo a solas, en un ambiente sereno, con una intención clara en tu corazón.',
      intention:
        'Sanar memorias, abrir el alma a la revelación y permitir una renovación interior.',
    },
  },
  {
    id: 'audio-4',
    title: 'Canto de Flauta en la Naturaleza',
    desc: 'Una melodía espiritual que fluye como un río de paz entre los paisajes del corazón. La flauta, unida a los sonidos de la naturaleza, despierta una sensación de libertad, suavidad y comunión con la belleza divina de la creación.',
    duration: '7:30',
    src: 'https://cdn.shopify.com/s/files/1/0981/0781/8286/files/Canto_de_Flauta_en_la_Naturaleza.mp3?v=1777006281',
    guide: {
      when: 'En momentos de contemplación, caminatas tranquilas, descanso o conexión con la naturaleza.',
      how: 'Preferiblemente con audífonos, dejando que el sonido te envuelva y te lleve a un estado de serenidad.',
      intention:
        'Abrir el corazón, recuperar la calma y sentirte acompañado por una presencia de amor y armonía.',
    },
  },
]
